import { useEffect, useState } from "react";
import axios from "axios";
import * as XLSX from 'xlsx';
import requests from "../services/httpService";


function EnquiryList() {
  const [contacts, setContacts] = useState([]);
  const [loading, setLoading] = useState(true);
  const token = localStorage.getItem('authToken');

  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/enquiry`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.data.status == true) {
          setContacts(response.data.data)
        }
        else {
          console.log("error");
        }

      } catch (error) {
        console.error("Error fetching contacts:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContacts();
  }, []);


  return (
    <>
      <div className="right_col" role="main">

        {loading ? (
          <p>Loading...</p>
        ) : (
          <div className="enquirylistnow">
            <div className="d-md-flex  align-items-center justify-content-between my-4 page-header-breadcrumb">

              <div className="my-auto">

                <h5 className="page-title fs-21 mb-1">
                  Enquiry List                     </h5>
                <nav>

                  <ol className="breadcrumb mb-0">

                    <li className="breadcrumb-item">
                      <a href="javascript:void(0);">Home</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                      Enquiry
                    </li>
                  </ol>
                </nav>
              </div>
              <div className="d-flex my-xl-auto gap-2 right-content align-items-center">



              </div>
            </div>

            <div className="table-responsive designtable bg-white">
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Services</th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Phone</th>
                    <th>Message</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  {contacts.map((contact) => (
                    <tr key={contact._id}>
                      <td>{contact.service.title}</td>
                      <td>{contact.name}</td>
                      <td>{contact.email}</td>
                      <td>{contact.phone}</td>
                      <td>{contact.message}</td>
                      <td>
                        {new Date(contact.createdAt)
                          .toLocaleDateString("en-GB")
                          .replace(/\//g, "-")}
                      </td>

                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </>
  );
}

export default EnquiryList;
